module.exports = __webpack_public_path__ + "media/act2.a0a8db55.mp4";